import { CollisionDetection, rectIntersection } from "@dnd-kit/core";

export const customRectangleIntersection: CollisionDetection = (args) => {
  const { collisionRect, droppableContainers } = args;

  const drawerCollider = droppableContainers.find(
    (container) => container.id === "drawer"
  );

  const drawerRectLeft = drawerCollider?.rect?.current?.left;
  const isHalfOverDrawer =
    drawerRectLeft &&
    drawerRectLeft < collisionRect.left + collisionRect.width / 2;

  // First, if the collision rect is half over the drawer, we want to prioritize the drawer as the target
  if (collisionRect && drawerCollider?.rect.current && isHalfOverDrawer) {
    // force the drawer as the target
    return rectIntersection({
      ...args,
      collisionRect: drawerCollider.rect.current,
    });
  }

  // Once the card is outside of the drawer, we instead want to remove any droppableContainers that are 100px or less away from the left edge of the drawer.
  // Basically, if we just did this and not the drawer check first, when we are hovering the drawer and a container below it is more than 100px away from the left edge of the drawer, it would be considered as a target instead of the drawer.
  const filteredDroppableContainers = droppableContainers.filter(
    (container) => {
      if (!drawerRectLeft) {
        return true;
      }

      return (
        container?.rect.current &&
        container.rect.current.left < drawerRectLeft - 100
      );
    }
  );

  return rectIntersection({
    ...args,
    droppableContainers: filteredDroppableContainers,
  });
};
